import React, { useEffect } from "react";
import "./MeetOurFounder.scss";
import Instagram from "../../images/instagram.svg";
import X from "../../images/x-icon.svg";
import LinkedIn from "../../images/linked-in-icon.svg";
import uTube from "../../images/youtube-icon.svg";

const MeetOurFounder = () => {
  useEffect(() => {
    // Store a function on the global window object to pause the YouTube video
    window.pauseYouTubeVideo = () => {
      const iframe = document.querySelector("iframe");
      if (iframe) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }
    };
  }, []);

  return (
    <section className="meet-founder">
      <div className="container">
        <div className="meet-founder__header">
          <h2>
            Meet our founder <span>the_cycledad</span>
          </h2>
        </div>

        <div className="meet-founder__st">
          <div className="video-iframe-wrapper">
            <iframe
              src="https://www.youtube.com/embed/aR9eWNAvXjo?enablejsapi=1"
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="meet-founder__links">
          <h3>
            Follow him on his journey to
            <span>#MakeCitiesLiveableAgain</span>
          </h3>

          <div className="contact-links">
            <a
              href="https://www.instagram.com/mybyk.in?igsh=MWtwZzY3d2Nwa254Mg=="
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={Instagram}
                alt="instagram-social"
                aria-label="instagram"
              />
            </a>
            <a
              href="https://twitter.com/mybyk_in"
              target="_blank"
              rel="noreferrer"
            >
              <img src={X} alt="x-social" aria-label="twitter" />
            </a>
            <a
              href="https://www.linkedin.com/company/mybyk"
              target="_blank"
              rel="noreferrer"
            >
              <img src={LinkedIn} alt="linkedin-social" aria-label="linkedin" />
            </a>
            <a
              href="https://www.youtube.com/@mybykindia"
              target="_blank"
              rel="noreferrer"
            >
              <img src={uTube} alt="youtube-social" aria-label="youtube" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetOurFounder;
